module.exports = __webpack_public_path__ + "assets/lessons/en/lesson5/pages/lesson_5_10.pdf";